import { render, staticRenderFns } from "./LearnSort.vue?vue&type=template&id=21b43fe8&scoped=true&"
import script from "./LearnSort.vue?vue&type=script&lang=js&"
export * from "./LearnSort.vue?vue&type=script&lang=js&"
import style0 from "./LearnSort.vue?vue&type=style&index=0&id=21b43fe8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b43fe8",
  null
  
)

export default component.exports